module.exports = __webpack_public_path__ + "img/sv68on.4066653d.svg";